import {
  Box,
  CircularProgress,
  circularProgressClasses,
  Typography,
} from "@mui/material";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles({
  spinner: {
    height: "85px",
    display: "flex",
    "& span": {
      position: "relative",
      margin: "auto",
    },
  },
});

const LoadingSpinner = ({ id }) => {
  const classes = useStyles();

  return (
    <>
      <Box className={classes.spinner}>
        <CircularProgress
          variant="indeterminate"
          disableShrink
          sx={{
            color: (theme) =>
              theme.palette.mode === "light" ? "#1a90ff" : "#308fe8",
            animationDuration: "550ms",
            position: "absolute",
            left: 0,
            [`& .${circularProgressClasses.circle}`]: {
              strokeLinecap: "round",
            },
          }}
          size={40}
          thickness={4}
          className="m-auto position-relative"
        />
      </Box>
    </>
  );
};
export default LoadingSpinner;
